<template>
	<page>
		<module enable-flex ref="view">
			<m-search ref="search" @search="searchHandle">
				<c-form ref="form">
					<c-form-item type="datetime" label="变化时间" start-name="start_date" end-name="end_date"></c-form-item>
					<c-form-item type="input" label="会员信息" name="user_info" placeholder="匹配昵称、手机号"></c-form-item>
					<c-form-item type="select" label="收支类型" name="income_expenses" :options="stateOptions"></c-form-item>
					<c-form-item type="select" label="业务类型" name="type" :options="typeOptions"></c-form-item>
				</c-form>
			</m-search>

            <m-operate>
                <c-button color="m" hollow @click="syncExport()">导出</c-button>

                <template #right>
                    <c-button v-if="userInfo.id == 1" color="red" @click="$refs.view.editExportColumn(workType)">编辑导出列</c-button>
                </template>
            </m-operate>
			
			<c-table ref="table">
                <c-table-column type="selector"></c-table-column>

                <c-table-column
					label="收支时间"
					name="create_date"
					width="140"
				></c-table-column>

				<c-table-column
					label="收支类型"
					name="income_expenses"
					width="80"
				>
				  <template v-slot="{data}">
					<span v-if="data.income_expenses == 1" style="color:green">收入</span>
					<span v-if="data.income_expenses == 2" style="color:red">支出</span>
				  </template>
				</c-table-column>

				<c-table-column
					label="业务类型"
					name="type"
					width="110"
				>
				  <template v-slot="{data}">
					<span>{{typeName[data.type]}}</span>
				  </template>
				</c-table-column>

				<c-table-column
					label="变更积分"
					name="points"
					width="90"
				>
					<template v-slot="{data}">
                      <span v-if="data.income_expenses == 1" style="color:green"> + {{data.points}}</span>
                      <span v-if="data.income_expenses == 2" style="color:red"> - {{data.points}}</span>
					</template>
				</c-table-column>

                <c-table-column
                        label="用户头像/昵称"
                        name="head_photo"
                        width="120"
                >
                    <template v-slot="{data}">
                        <div class="flex-center-cross">
                            <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                            <span>{{data.nick_name}}</span>
                        </div>
                    </template>
                </c-table-column>

                <c-table-column
                        label="用户手机"
                        name="user_manage_mobilephone"
                        width="120"
                >
                </c-table-column>

				<c-table-column
					label="详细说明"
					name="remark"
					width="700"
				></c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	import {mapState} from "vuex";

    export default {
		name: 'm_points_recort',

        computed: {
            ...mapState(['systemConfig', 'userInfo'])
        },

		data() {
			return {
                workType:28,
                searchParams:{},
                stateOptions: [
                    {name: '收入',value: 1},
                    {name: '支出',value: 2}
				],
                typeOptions: [
                    {name: '下单奖励',value: 1},
                    {name: '下单抵扣',value: 6},
                    {name: '积分商城消费',value: 2},
                    {name: '签到奖励',value: 3},
                    {name: '订单取消返还',value: 7},
                    {name: '积分抽奖',value: 5},
                    {name: '积分抽奖中奖',value:8},
                    {name: '过期失效',value:-1}
                ],
                typeName: {
                    '-1':'过期失效',
                    1: '下单奖励',
                    2: '积分商城消费',
                    3: '签到奖励',
                    5: '积分抽奖',
                    6: '下单抵扣',
                    7: '订单取消返还',
                    8: '积分抽奖中奖'
                },
			}
		},

		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/points/record/list',
					data
				});
                this.searchParams = data||{};
            },

            /**同步导出数据*/
            syncExport(){
                var selectDatas = this.$refs.table.getRow('selected');
                var ids = [];
                if (selectDatas.length && selectDatas.length>0) {
                    ids = Array.from(selectDatas, item => item.data.id);
                }
                this.export(this.workType,this.searchParams,ids);
            },

            /**异步导出数据*/
            exportData(){
                var exportData = this.$refs.form.serialize();
                exportData.job_id = 37;
                exportData.create_system = 'OMS';

                this.request({
                    url: '/export_job/add',
                    data: exportData,
                    success: data => {
                        this.$message({
                            text: '导出任务创建成功，请前往任务中心查看导出进度',
                            icon: 'success'
                        });
                    }
                });
            }
		}
	}
</script>